import React, { createContext, useContext, useState } from "react"

import api from "../../services/api"
import log from "../../services/log"

type UserContextType = {
  userId: number
  userEmail: string
  newsletterAccepted: boolean
  hasMadeAnyChange: boolean
  isAdmin: boolean
  retry: () => Promise<any>
  logout: () => Promise<any>
}

const UserContext = createContext<UserContextType>({
  userId: 0,
  userEmail: "",
  newsletterAccepted: false,
  hasMadeAnyChange: true,
  isAdmin: false,
  retry: () => Promise.resolve(),
  logout: () => Promise.resolve(),
})

export const UserProvider = ({ children }) => {
  const serverProvidedMeInfo = (window as any).nanaMe as any
  const [userId, setUserId] = useState<number>(serverProvidedMeInfo.id)
  const [userEmail, setUserEmail] = useState<string>(serverProvidedMeInfo.email)
  const [newsletterAccepted, setNewsletterAccepted] = useState(
    serverProvidedMeInfo.newsletter_accepted
  )
  const [hasMadeAnyChange, setHasMadeAnyChange] = useState(serverProvidedMeInfo.made_any_change)
  const [isAdmin, setIsAdmin] = useState(serverProvidedMeInfo.is_admin)

  const retry = () => {
    return api()
      .get("/api/me")
      .then(({ data }) => {
        if (data.status === "logged_in") {
          setUserId(data.id)
          setUserEmail(data.email)
          setNewsletterAccepted(data.newsletter_accepted)
          setHasMadeAnyChange(data.made_any_change)
          setIsAdmin(data.is_admin)
          log("ACCOUNT", "#FDF", `got me ${data.id}`)
        } else {
          log("ACCOUNT", "#FDF", `logged out`)
        }
      })
  }

  const logout = () => {
    return api()
      .get("/api/logout")
      .then(({ data }) => {
        if (data.status === "ok") {
          log("ACCOUNT", "#FDF", `logged out`)
          setUserId(0)
          setUserEmail("")
          setNewsletterAccepted(false)
          setHasMadeAnyChange(false)
          setIsAdmin(false)
        } else {
          console.error("ACCOUNT: /api/logout", data)
        }
      })
  }

  return (
    <UserContext.Provider
      value={{
        userId,
        userEmail,
        newsletterAccepted,
        hasMadeAnyChange,
        isAdmin,
        retry,
        logout,
      }}
    >
      {children}
    </UserContext.Provider>
  )
}

export const useAuth = () => {
  return useContext(UserContext)
}
